<template>

    <card-list-item @click="">
        <template v-slot:icon><i class="far fa-code-merge fa-fw"></i></template>
        <template v-slot:content>
            <div class="columns">
                <div class="column is-9">
                    <div class="tile-title" v-if="titles[activity.data.endpoint]">{{titles[activity.data.endpoint]}}</div>
                    <div class="meta"><b-tag size="is-small" :type="getTypeColor(activity.data.method)" class="mr-2">{{activity.data.method}}</b-tag>{{activity.data.endpoint}}</div>
                </div>
                <div class="column">
                    <div class="meta" v-if="activity.data.user">
                        <i class="fas fa-user mr-2"></i>{{activity.data.user.first_name}} {{activity.data.user.last_name}}
                    </div>
                </div>
            </div>

<!--            <json-viewer :value="activity" :expand-level="1"></json-viewer>-->
        </template>
        <template v-slot:status>
            <div class="stats">
                <span class="stat">{{activity.date | moment('MMM D YYYY, h:mm a')}}</span>
            </div>
        </template>
        <template v-slot:details>
            <div class="mt-3">
                <!--                            <toolbar class="toolbar">-->
                <!--                                <button class="icon-only" @click.stop=""><i class="far fa-pencil"></i></button>-->
                <!--                            </toolbar>-->

                <div class=" mt-1">
                    <div class="meta mt-3">

                    </div>

                </div>
            </div>
        </template>
    </card-list-item>
</template>

<script>
    import CardListItem from "../../TIER/components/CardListItem";
    export default {
        name: "ActivityTraffic",
        components: {CardListItem},
        props: ['activity'],
        data() {
            return {
                titles
            };
        },
        methods: {
            getTypeColor: function() {
                if (this.activity.data.method === 'GET') {
                    return 'is-info';
                } else if (this.activity.data.method === 'POST') {
                    return 'is-success';
                } else if (this.activity.data.method === 'PUT') {
                    return 'is-warning';
                } else if (this.activity.data.method === 'DELETE') {
                    return 'is-danger';
                }
            }
        }
    };

    let titles = {
        '/app/registrations/': 'Conference Registrations',
    }
</script>

<style lang="scss" scoped>
    .tile-title {
        font-size: 0.9rem;
        font-weight: bold;
    }
</style>
